import $ from 'jquery';
import { setCookie, getCookie } from '../engine/helpers/cookie';

export default class AvatarGenerator {
  constructor() {

    this.holder = $(document).find(".modal.guest-welcome-modal-holder");
    this.template = this.holder.find("#avatarDiv");
    if (!this.holder[0]) {
      return;
    }

    this.input = this.holder.find("#guest-avatar-name");
    let guestName = getCookie('guestName');
    this.input[0].value = guestName;
    this.input.on("keydown", this.generate);
    this.input.on("keyup", this.generate);
    this.input.on("change", this.generate);
    this.saveButton = $("#save-welcome-guest");
    this.input.trigger("keyup");

    this.wrapper = this.template[0];
    this.img = $("#avatar-welcome-screen")[0];
    if (guestName) {
      this.generate();
    }
    // this.img.src = "/textures/icon_avatar.png"


    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }
    this.lighteness = Math.round(getRandomArbitrary(40, 80));
    this.saturation = Math.round(getRandomArbitrary(24, 100));


  }
  generate = () => {
    // take input values from the user
    var name = this.input[0].value;
    // if (this.img.style.display === "none") {
    //   this.img.style.display = "block";
    // }
    if (name === "" || name.length < 2) {
      this.saveButton.addClass("disabled");
      this.img && (this.img.src = "/textures/bagless_logo.png");
      return;
      // this.img.style.display = "none"
    }
    this.saveButton.removeClass("disabled");
    setCookie('guestName', name, 30);

    let _myNames;
    let _initials;
    if (name.split(" ").length > 1) {
      _myNames = name.split(" ");
      _initials = _myNames.shift().charAt(0) + _myNames.pop().charAt(0);
    } else {
      _initials = name.charAt(0) + name.charAt(name.length - 1);
    }
    let _nameInitials = _initials.toUpperCase();
    if (this.isOnlySpaces(_nameInitials)) {
      this.img && (this.img.src = "/textures/bagless_logo.png");
      return;
    }
    if (_nameInitials.length === 1) {
      _nameInitials = `${_nameInitials}${_nameInitials}`
    }
    this.img && (this.img.src = "./images/generated/" + _nameInitials);
    return;
  }

  generateAvatar = (text, foregroundColor = "white", backgroundColor = "black") => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.width = 200;
    canvas.height = 200;

    // Draw background
    context.fillStyle = backgroundColor;
    context.fillRect(0, 0, canvas.width, canvas.height);

    // Draw text
    context.font = "bold 90px Arial";
    context.fillStyle = foregroundColor;
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.fillText(text, canvas.width / 2, canvas.height / 2);

    return canvas.toDataURL("image/png");
  }
  isOnlySpaces = (str) => {
    return /^[\s]*$/.test(str);
  }

}
